// extracted by mini-css-extract-plugin
export default {"container":"EvoScadaServer_container__iM2uA"};